export default __webpack_public_path__ + "static/Romie-Regular-8ceaa06ad374b05e11b25ad06284167a.woff2";